import React, { Component } from 'react';
import Loader from 'react-loader-spinner'; 

class Loading extends Component {
  constructor() {
    super();
    ;
}
  
render() {
   return (
     <div className="loading" >
       <Loader type="ThreeDots" color="#009cff" height="100" width="100" />
    </div>
    );
  }
}

export default Loading